
import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import Portabilty_FPS from "./Portabilty_FPS";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";

function PortabilityJsoTable({ distCode, selectedMonth, selectedYear, onDataLoaded }) {
  const [JSOData, setJSOData] = useState([]);
  const [jsoTitle, setJsoTitle] = useState("");
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState("");
  const [renderContent, setRenderContent] = useState(null);
    const [error, setError] = useState(null);
    const detailsRRef = useRef(null);

  const nextTableRef = useRef(null);
  const currentTableRef = useRef(null);

  useEffect(() => {
    if (!distCode) return;
    setRenderContent(null);
    setLoading(true);

    axios
      .post(`${process.env.REACT_APP_URL_SIDE}/PortabilityAbstract/Portabilty_Afso`, {
        distCode,
        month: selectedMonth,
        year: selectedYear,
      })
      .then((response) => {
        setLoading(false);
        if (response.data.message) {
          setMessage(response.data.message);
          setJSOData([]);
          if (onDataLoaded) onDataLoaded();
        } else {
          setJsoTitle(response.data.title || "JSO Report");
          setJSOData(response.data.data || []);
          setMessage("");
        }
      })
      .catch((error) => {
        console.error("Error fetching JSO data:", error);
        setLoading(false);
        setJSOData([]);
        setMessage("Internal error");
      });
  }, [distCode, selectedMonth, selectedYear]);

  // Extract scheme headers from the first row of data
  const schemeHeaders = JSOData.length > 0 ? JSOData[0].schemeList || [] : [];

  const calculateSchemeTotals = (schemeId) => {
    return JSOData.reduce(
      (sum, row) => {
        const found = row.schemeList?.find((s) => s.scheme_id === schemeId);
        return {
          avail_cards: sum.avail_cards + (found?.avail_cards || 0),
          avail_trans: sum.avail_trans + (found?.avail_trans || 0),
          avail_port_cards: sum.avail_port_cards + (found?.avail_port_cards || 0),
          avail_port_trans: sum.avail_port_trans + (found?.avail_port_trans || 0),
        };
      },
      { avail_cards: 0, avail_trans: 0, avail_port_cards: 0, avail_port_trans: 0 }
    );
  };

  // Grand Totals Calculation
  const total_cards = JSOData.reduce((sum, row) => sum + (row.total_cards || 0), 0);
  const totalAvailCards = JSOData.reduce((sum, row) => sum + (row.avail_cards || 0), 0);
  const totalAvailTrans = JSOData.reduce((sum, row) => sum + (row.avail_trans || 0), 0);
  const totalPortCards = JSOData.reduce((sum, row) => sum + (row.avail_port_cards || 0), 0);
  const totalPortTrans = JSOData.reduce((sum, row) => sum + (row.avail_port_trans || 0), 0);

  const totalAvailPercent = totalAvailCards
    ? ((totalPortCards * 100) / totalAvailCards).toFixed(2)
    : "0.00";

  const onJsoClick = (afsoCode) => {
    setRenderContent(
      <div ref={nextTableRef}>
        <Portabilty_FPS
          afsoCode={afsoCode}
          selectedMonth={selectedMonth}
          selectedYear={selectedYear}
          distCode={distCode}
        />
      </div>
    );
  };


  useEffect(() => {
    if (!loading && JSOData.length > 0 && currentTableRef.current) {
        // Only scroll to the main table if it's the first load or year/month changed
        currentTableRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }, [loading, JSOData]);


  const handleDownload = () => {
    const tableSelect = document.getElementById("jsoReportTable");
    if (!tableSelect) return;
    const dataType = "application/vnd.ms-excel";
    const tableHTML = tableSelect.outerHTML.replace(/ /g, "%20");
    const downloadLink = document.createElement("a");
    document.body.appendChild(downloadLink);
    downloadLink.href = "data:" + dataType + ", " + tableHTML;
    downloadLink.download = `JSO_Report_${distCode}.xls`;
    downloadLink.click();
    document.body.removeChild(downloadLink);
  };


  if (loading) {
    return (
      <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100px" }}>
        <Box sx={{ display: "flex" }}>
          <CircularProgress />
        </Box>
      </div>
    );
  }

  return (
    <div>
      {JSOData.length > 0 ? (
        <table border={1} align="center" id="jsoReportTable" width="95%" ref={currentTableRef}>
          <thead>
            <tr className="tableheader">
              <th colSpan={8 + schemeHeaders.length * 4}>{jsoTitle}</th>
            </tr>

            <tr className="tableheader">
              <th rowSpan={3}>Sl.No</th>
              <th rowSpan={3}>JSO </th>
              <th rowSpan={3}>Total Cards</th>

              {schemeHeaders.map((sch, idx) => (
                <th key={idx} colSpan={4}>{sch.scheme_short_name}</th>
              ))}

              <th colSpan={4}>TOTAL</th>
              <th rowSpan={3}>% (Port Cards/Avail Cards)</th>
            </tr>

            <tr className="tableheader">
              {schemeHeaders.map((_, idx) => (
                <React.Fragment key={idx}>
                  <th colSpan={2}>Regular</th>
                  <th colSpan={2}>Portability</th>
                </React.Fragment>
              ))}
              <th colSpan={2}>Regular</th>
              <th colSpan={2}>Portability</th>
            </tr>

            <tr className="tableheader">
              {schemeHeaders.map((_, idx) => (
                <React.Fragment key={idx}>
                  <th>Avail Cards</th>
                  <th>Avail Trans</th>
                  <th>Port Cards</th>
                  <th>Port Trans</th>
                </React.Fragment>
              ))}
              <th>Avail Cards</th>
              <th>Avail Trans</th>
              <th>Port Cards</th>
              <th>Port Trans</th>
            </tr>
          </thead>

          <tbody>
            {JSOData.map((row, index) => (
              <tr key={index}>
                <td>{index + 1}</td>
                <td
                  onClick={() => onJsoClick(row.afso_code)}
                  style={{ cursor: "pointer", color: "blue" }}
                >
                  <u>{row.afso_name_en}</u>
                </td>
                <td style={{ textAlign: "right" }}>{row.total_cards || 0}</td>

                {/* Scheme Specific Data mapping */}
                {schemeHeaders.map((sch, idx) => {
                  const found = row.schemeList?.find((s) => s.scheme_id === sch.scheme_id);
                  return (
                    <React.Fragment key={idx}>
                      <td style={{ textAlign: "right" }}>{found?.avail_cards || 0}</td>
                      <td style={{ textAlign: "right" }}>{found?.avail_trans || 0}</td>
                      <td style={{ textAlign: "right" }}>{found?.avail_port_cards || 0}</td>
                      <td style={{ textAlign: "right" }}>{found?.avail_port_trans || 0}</td>
                    </React.Fragment>
                  );
                })}

                {/* JSO Total Data */}
                <td style={{ textAlign: "right" }}>{row.avail_cards || 0}</td>
                <td style={{ textAlign: "right" }}>{row.avail_trans || 0}</td>
                <td style={{ textAlign: "right" }}>{row.avail_port_cards || 0}</td>
                <td style={{ textAlign: "right" }}>{row.avail_port_trans || 0}</td>

                <td style={{ textAlign: "right" }}>
                  {row.avail_cards
                    ? ((row.avail_port_cards * 100) / row.avail_cards).toFixed(2)
                    : "0.00"}
                </td>
              </tr>
            ))}
          </tbody>

          <tfoot>
            <tr className="tableheader">
              <th colSpan={2}>Total</th>
              <th style={{ textAlign: "right" }}>{total_cards}</th>

              {/* Footer Totals per Scheme */}
              {schemeHeaders.map((sch, idx) => {
                const sTotal = calculateSchemeTotals(sch.scheme_id);
                return (
                  <React.Fragment key={idx}>
                    <th style={{ textAlign: "right" }}>{sTotal.avail_cards}</th>
                    <th style={{ textAlign: "right" }}>{sTotal.avail_trans}</th>
                    <th style={{ textAlign: "right" }}>{sTotal.avail_port_cards}</th>
                    <th style={{ textAlign: "right" }}>{sTotal.avail_port_trans}</th>
                  </React.Fragment>
                );
              })}

              {/* Grand Total Footer */}
              <th style={{ textAlign: "right" }}>{totalAvailCards}</th>
              <th style={{ textAlign: "right" }}>{totalAvailTrans}</th>
              <th style={{ textAlign: "right" }}>{totalPortCards}</th>
              <th style={{ textAlign: "right" }}>{totalPortTrans}</th>
              <th style={{ textAlign: "right" }}>{totalAvailPercent}</th>
            </tr>

            <tr align="center">
              <td colSpan={8 + schemeHeaders.length * 4 + 1}>
                <button className="button button2" onClick={handleDownload}>
                  Export to Excel
                </button>
              </td>
            </tr>
          </tfoot>
        </table>
      ) : (
        <div className="mainhead" align="center">
          {message}
        </div>
      )}

      <br />
      {renderContent}
    </div>
  );
}

export default PortabilityJsoTable;